var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"row m-0"},[_c('div',{staticClass:"col-md-8 p-0 bk-gray"},[_c('router-view')],1),_c('div',{staticClass:"col-md-4 bk-green"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }